import {Nullable} from '../../../../Common/TypeHelper'

export type PhotoContent = {
  title: string
  file: string
  fileName: string
  publishDate: string
  publishDateTime: string
  publishEndDate: string
  publishEndDateTime: string
  publishEndDateCheck: boolean
}

export interface PhotoContentJSON {
  id: number
  title: string
  url: string
  fileName: string
  publishDate: string
  publishEndDate: Nullable<string>
  bucketKey: string
}

export class PhotoContentDTO implements PhotoContentJSON {
  constructor(
    public id: number,
    public title: string,
    public url: string,
    public fileName: string,
    public publishDate: string,
    public publishEndDate: Nullable<string>,
    public bucketKey: string,
  ) {
  }

  static fromJSON(jsonObject: PhotoContentJSON): PhotoContentDTO {
    return new PhotoContentDTO(
      jsonObject.id,
      jsonObject.title,
      jsonObject.url,
      jsonObject.fileName,
      jsonObject.publishDate,
      jsonObject.publishEndDate,
      jsonObject.bucketKey,
    )
  }

}
